import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelectorNavbar.css';

interface LanguageSelectorNavbarProps {
  className?: string;
  isDarkTheme?: boolean;
}

const LanguageSelectorNavbar: React.FC<LanguageSelectorNavbarProps> = ({ 
  className = '',
  isDarkTheme = false
}) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
    
    const path = window.location.pathname;
    
    if (lng === 'fr') {
      if (path.startsWith('/en/')) {
        const newPath = path.substring(3);
        window.history.pushState({}, '', newPath);
      } else if (path === '/en') {
        window.history.pushState({}, '', '/');
      }
    } else if (lng === 'en') {
      if (path.startsWith('/en/')) {
      } else if (path === '/en') {
      } else if (path === '/') {
        window.history.pushState({}, '', '/en');
      } else if (path.startsWith('/')) {
        window.history.pushState({}, '', `/en${path}`);
      } else {
        window.history.pushState({}, '', `/en/${path}`);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const currentLanguage = i18n.language || 'fr'; // Default to 'fr' to prevent undefined state
  const currentLang = currentLanguage === 'fr' ? 'Français' : 'English';
  const otherLang = currentLanguage === 'fr' ? 'English' : 'Français';
  const otherLangCode = currentLanguage === 'fr' ? 'en' : 'fr';

  // Prevent rendering until i18n is ready to avoid flickering
  if (!i18n.language) {
    return null;
  }

  return (
    <div className={`language-selector-navbar ${className}`} ref={containerRef}>
      <button 
        className={`language-current ${isDarkTheme ? 'dark-theme' : 'light-theme'}`}
        onClick={toggleDropdown}
      >
        <span className="dropdown-arrow">▼</span>
        {currentLang}
      </button>
      
      {isOpen && (
        <div 
          className={`language-dropdown ${isDarkTheme ? 'dark-theme' : 'light-theme'}`}
        >
          <button
            className="language-option"
            onClick={() => changeLanguage(otherLangCode)}
          >
            {otherLang}
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSelectorNavbar; 